module.exports = __webpack_public_path__ + "static/media/Ron Weasley 1.770257c9.jpg";